<script setup>
import { computed } from 'vue'
import { Avatar, AvatarImage, AvatarFallback } from '@/shadcn/components/ui/avatar'
import { useUserAvatarBackgroundColor } from '@/hooks/use-user-avatar-background-color.js'
import { isGravatarImage } from '@/utils.js'

const props = defineProps({
  imageUrl: {
    type: String,
    default: ''
  },
  displayName: {
    type: String,
    required: true
  }
})

const avatarImageUrl = computed(() => {
  // If the image URL is the default Gravatar URL, return an empty string
  if (isGravatarImage(props.imageUrl)) {
    return ''
  }

  return props.imageUrl
})

const { getUserAvatarBackgroundColor } = useUserAvatarBackgroundColor()
const hsl = computed(() => getUserAvatarBackgroundColor(props.displayName))

</script>

<template>
  <Avatar class="UserAvatar">
    <AvatarImage
      :src="avatarImageUrl"
      :alt="displayName"
    />
    <AvatarFallback
      class="tw-text-white tw-font-semibold tw-uppercase"
    >
      {{ displayName.slice(0, 1) }}
    </AvatarFallback>
  </Avatar>
</template>

<style scoped>
.UserAvatar {
  background-color: v-bind(hsl);
}
</style>
